import { BiCollapseAlt } from "react-icons/bi";
import "./TagSingleSelector.css";
import { TagSelector } from "../TagSelector/TagSelector";
import { TagType } from "../../enums/tagTypes";
import { useState } from "react";
import { DynamicIcon } from "../DynamicIcon/DynamicIcon";

export function TagSingleSelector({
	parentId = null,
	selectedTag,
	onTagChange,
	customFilter,
	label = "Etiqueta",
	type = TagType.PERSON,
	disabled = false,
	filters = {},
	...props
}) {
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	return (
		<>
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				<label htmlFor="select-tag-button" style={{ textAlign: 'left', color: 'var(--textColor)', marginBottom: 5 }}>
					{label}
				</label>
				<button
					type='button'
					id="select-tag-button"
					className={`btn-select`}
					disabled={disabled || isLoading}
					onClick={e => setModalIsOpen(true)}
				>
					{isLoading ? (
						<span>
							Carregando...
						</span>
					) : (
						<span>
							{selectedTag ? (
								<div className="tag-item-clean" style={{ '--tagColor': selectedTag.color }}>
									<span>
										{selectedTag.icon ? (
											<DynamicIcon iconName={selectedTag.icon} color={selectedTag.color} size={17} />
										) : (
											<span></span>
										)}
										{selectedTag.name}
									</span>
								</div>
							) : (
								`Selecione uma ${label.toLowerCase()}`
							)}
						</span>
					)}
					<BiCollapseAlt />
				</button>
			</div >
			<TagSelector
				parentId={parentId}
				tags={selectedTag ? [selectedTag] : []}
				type={type}
				onTagsChange={tags => onTagChange(tags?.[0])}
				isOpen={modalIsOpen}
				onClose={() => setModalIsOpen(false)}
				onLoading={() => setIsLoading(true)}
				onLoad={() => setIsLoading(false)}
				single={true}
				customFilter={customFilter}
				filters={filters}
			/>
		</>
	);
}